import { render, staticRenderFns } from "./Agradecimento.vue?vue&type=template&id=0c795897&scoped=true&lang=pug&"
import script from "./Agradecimento.vue?vue&type=script&lang=js&"
export * from "./Agradecimento.vue?vue&type=script&lang=js&"
import style0 from "./Agradecimento.styl?vue&type=style&index=0&id=0c795897&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c795897",
  null
  
)

export default component.exports